<template>
  <div>
    <fieldset ref="split_helper">
      <AVSplitHelper
        :contest="filteredContest"
        :contestSelection="contestSelection"
        :includeLazyErrors="includeLazyErrors"
        :weight="1"
        @update:contestSelection="updateActiveContestSelection"
        @update:complete="updateCompleted"
        @update:activePile="updateActivePile"
      />
    </fieldset>
    <input type="hidden" :name="`${formScope}[explicit_blank]`" :value="activePile.explicitBlank">
    <template v-for="optionSelection in activePile.optionSelections">
      <input type="hidden" :name="`${formScope}[selected_option_references][]`" :value="optionSelection.reference">
    </template>
    <div class="mt-3 hstack gap-2">
      <button type="submit" class="btn btn-primary" :disabled="!completed">{{ $t("backend.contest_selections.form.confirm_selections") }}</button>
      <a href="." class="btn btn-secondary">{{ $t("backend.actions.cancel") }}</a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type {
  PropType,
  SelectionPile,
  ContestSelection,
  ConferenceOption,
} from "@/types";
import { ContestContent } from '@assemblyvoting/js-client/dist/lib/av_client/types';
export default defineComponent({
  name: "ContestSelectionForm",
  props: {
    contest: {
      type: Object as PropType<ContestContent>,
      required: true,
    },
    initialContestSelection: {
      type: Object as PropType<ContestSelection>,
      required: true,
    },
    formScope: {
      type: String,
      required: true,
    },
  },
  computed: {
    filteredContest() {
      return { ...this.contest, options: this.filterWriteIns(this.contest.options) };
    },
  },
  mounted() {
    this.$refs.split_helper.querySelectorAll("button").forEach((el) => { el.type = "button" })
  },
  data({ initialContestSelection }) {
    return {
      includeLazyErrors: false,
      completed: false,
      contestSelection: structuredClone(initialContestSelection),
      activePile: initialContestSelection.piles[0] ?? { multiplier: 1, optionSelections: [], explicitBlank: false },
    }
  },
  methods: {
    updateCompleted(completed: boolean) {
      this.completed = completed;
      if (completed) this.includeLazyErrors = true;
    },
    updateActivePile(newPile: SelectionPile) {
      this.activePile = newPile;
    },
    updateActiveContestSelection(contestSelection: ContestSelection) {
      Object.assign(this.contestSelection, contestSelection)
    },
    filterWriteIns(options: ConferenceOption[]) {
      return options.map(option =>
        ({
          ...option,
          selectable: !option.writeIn,
          children: option.children ? this.filterWriteIns(option.children) : option.children,
        })
      );
    },
  },
});
</script>
